import React from 'react';

import Box from '~/common/components/Box';
import { propsMapper } from '~/common/components/PropertyMappers/propsMapper';

type SimpleGridProps = Omit<React.ComponentProps<typeof Box>, 'display'> & {
  columns?: number;
  spacingY?: number | string;
  spacingX?: number | string;
  spacing?: number | string;
};

const SimpleGrid = React.forwardRef<any, SimpleGridProps>(
  ({ children, ...props }, ref) => {
    const updatedProps = {
      display: 'grid',
      ...props,
    };

    return (
      <Box ref={ref} {...propsMapper(updatedProps)}>
        {children}
      </Box>
    );
  },
);

SimpleGrid.displayName = 'SimpleGrid';

export default SimpleGrid;
